import { AsyncArray } from '../../types';

export enum TipoTrabalho {
  INDIVIDUAL = 'INDIVIDUAL',
  GRUPO = 'GRUPO',
}

export interface AvaliacaoTrabalho {
  tipo: 'NOTA' | 'CONCEITO' | 'NENHUMA_CORRECAO';
  valorMaximo?: number;
}

export interface NovoTrabalho {
  entregas: string[];
  titulo: string;
  obrigatorio: boolean;
  tipoTrabalho: 'INDIVIDUAL' | 'GRUPO';
  avaliacao: AvaliacaoTrabalho;
  enunciado?: string;
  prazoEntrega?: Date;
}

export enum TipoMaterialApoio {
  LINK = 'LINK',
  ARQUIVO = 'ARQUIVO',
}

export enum StatusMaterialApoio {
  ATIVO = 'ATIVO',
  REMOVIDO_PELO_USUARIO = 'REMOVIDO_PELO_USUARIO',
  UPLOAD_PENDENTE = 'UPLOAD_PENDENTE',
}

interface MaterialApoioDefault {
  tipo: TipoMaterialApoio;
  id?: number;
  status?: StatusMaterialApoio;
}

export interface MaterialApoioLink extends MaterialApoioDefault {
  tipo: TipoMaterialApoio.LINK;
  url: string;
}
export interface MaterialApoioArquivo extends MaterialApoioDefault {
  tipo: TipoMaterialApoio.ARQUIVO;
  tipoArquivo: string;
  nomeArquivo: string;
  tamanhoEmMBs?: number;
}

export type MaterialApoio = MaterialApoioLink | MaterialApoioArquivo;

export interface Trabalho {
  id: string;
  disciplina?: string;
  entregas: string[];
  titulo: string;
  obrigatorio: boolean;
  tipoTrabalho: TipoTrabalho;
  temResposta: boolean;
  quantidadeMateriaisApoio: number;
  avaliacao: AvaliacaoTrabalho;
  permitirEnvioForaPrazo: boolean;
  prazoEntrega?: Date;
  idPrazoTrabalho?: string;
  enunciado?: string;
  modelo?: string;
  statusResposta?: 'RESPONDIDO' | 'NAO_RESPONDIDO' | 'FALHA_DE_ENVIO';
  dataAtualizacao?: Date;
}

export interface TrabalhoApiResponse {
  id: string;
  entregas: string[];
  titulo: string;
  modelo: string;
  obrigatorio: boolean;
  tipoTrabalho: TipoTrabalho;
  temResposta: boolean;
  quantidadeMateriaisApoio: number;
  avaliacao: AvaliacaoTrabalho;
  permitirEnvioForaPrazo: boolean;
  disciplina?: string;
  prazoEntrega?: string;
  enunciado?: string;
  idPrazoTrabalho?: string;
  statusResposta?: 'RESPONDIDO' | 'NAO_RESPONDIDO' | 'FALHA_DE_ENVIO';
  dataAtualizacao?: string;
}

export interface HookResult {
  getTrabalhos: () => AsyncArray<Trabalho>;
  getValorTrabalhos: () => Trabalho[];
  retentativa: () => void;
}

export interface HookInput {
  idTurma: string;
  precondicao: boolean;
}

export type Hook = (i: HookInput) => HookResult;
